import React from 'react';

const Adult = () => (
  <svg
    width="344"
    height="344"
    viewBox="0 0 344 344"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="172"
      cy="172"
      r="72"
      fill="#FF016C"
      fillOpacity=".15"
      filter="url(#filter0_18+)"
    />
    <path
      d="M148.637 159.368h4.08V185h5.28v-33.6h-3.552c-.816 2.256-1.728 4.224-5.808 4.224v3.744zm31.607 17.568v-2.64c0-3.216-.96-5.712-3.264-7.008 2.16-1.2 3.264-3.456 3.264-6.768v-1.056c0-5.376-2.928-8.448-8.256-8.448s-8.256 3.072-8.256 8.448v1.056c0 3.312 1.056 5.568 3.264 6.768-2.304 1.296-3.264 3.792-3.264 7.008v2.64c0 5.376 2.928 8.448 8.256 8.448s8.256-3.072 8.256-8.448zm-11.232-.144v-3.12c0-2.64 1.104-3.792 2.976-3.792 1.872 0 2.976 1.152 2.976 3.792v3.12c-.048 2.976-1.296 3.792-2.976 3.792s-2.976-.816-2.976-3.792zm0-17.136c0-3.024 1.296-3.84 2.976-3.84s2.976.816 2.976 3.84v1.872c0 2.688-1.296 3.552-2.976 3.552-1.728 0-2.976-.864-2.976-3.552v-1.872zm23.88.192h-3.744v6.48h-6.432v3.744h6.432v6.576h3.744v-6.576h6.432v-3.744h-6.432v-6.48z"
      fill="#fff"
      fillOpacity=".15"
    />
    <defs>
      <filter
        id="filter0_18+"
        x="0"
        y="0"
        width="344"
        height="344"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
);

export default Adult;
